<mat-grid-list [cols]="16 + (selectedTpr.designOnly ? 2 : 0)" gutterSize="25px" rowHeight="155px"
    class="grid-list-space">
    <mat-grid-tile colspan="3" class="align-items-inherit">
        <div class="display-style">
            <span class="label-wrapper">
                <mat-label>Scheduled Start:</mat-label>
            </span>
            <mat-form-field class="no-underline body-wrapper block">
                <input class="input-wrapper" matInput (ngModel)="selectedTpr.designSchedStart"
                    [ngModel]="selectedTpr.designSchedStart | date:'M/d/y'" readonly
                    [disabled]="disabled || reSourced || inActive || !fieldAuthorized('designSchedStart')" />
            </mat-form-field>
        </div>

        <div class="display-style">
            <span class="label-wrapper">
                <mat-label>Actual Start:</mat-label>
            </span>
            <mat-form-field class="display-field no-underline bg-green">
                <input matInput class="input-wrapper" [matDatepicker]="actualStartDatepicker2"
                    [(ngModel)]="selectedTpr.designActualStart"
                    (dateChange)="onGenericFieldChange('designActualStart',selectedTpr.designActualStart)"
                    [disabled]="disabled || reSourced || inActive || !fieldAuthorized('designActualStart')" />
                <mat-datepicker-toggle matSuffix [for]="actualStartDatepicker2"></mat-datepicker-toggle>
                <mat-datepicker #actualStartDatepicker2></mat-datepicker>
            </mat-form-field>
        </div>

        <div class="display-style">
            <span class="label-wrapper">
                <mat-label>Design Adj (days):</mat-label>
            </span>
            <searchable-autocomplete style="margin-top: -12px;" [options]="daysOpts" [exactMatch]="false"
                [numberInput]="true" filterBy="designSource" [(selected)]="selectedTpr.designWeeksAdj"
                [disabled]="disabled || reSourced || inActive || !fieldAuthorized('designWeeksAdj')"
                (select)="onGenericFieldChange('designWeeksAdj',selectedTpr.designWeeksAdj, true)">
            </searchable-autocomplete>
        </div>
    </mat-grid-tile>

    <mat-grid-tile colspan="2" class="align-items-inherit check-padding">
        <mat-checkbox #modelCheck class="checkbox-format text-center checkbox-6b" color="primary"
            [checked]="selectedTpr.modelPerc === 100"
            [disabled]="!selectedTpr.designActualStart || disabled || reSourced || inActive || !fieldAuthorized('model')"
            (change)="onModelCheckChange($event)">
            Complete
        </mat-checkbox>
        <div class="display-style">
            <span class="label-wrapper">
                <mat-label *ngIf="getEtac()">50% Model:</mat-label>
                <mat-label *ngIf="!getEtac()">10% Input Req'd & Understood:</mat-label>
            </span>
            <mat-form-field class="block no-underline bg-green">
                <input matInput class="input-wrapper" type="number" [(ngModel)]="selectedTpr.modelPerc"
                    [disabled]="!selectedTpr.designActualStart || disabled || reSourced || inActive || !fieldAuthorized('model')"
                    (change)="onModelPercChange(modelCheck)" name="modelInput"
                    pattern="^$|^([0-9]|[1-9][0-9]|[1][0][0])?" required #modelInput="ngModel"/>
                <div *ngIf="modelInput.errors && (modelInput.dirty || modelInput.touched)">
                    <div class="error-hint" [hidden]="!modelInput.errors.pattern">
                        Number should be between 0 and 100
                    </div>
                </div>
            </mat-form-field>
        </div>
    </mat-grid-tile>

    <mat-grid-tile colspan="2" class="align-items-inherit check-padding">
        <mat-checkbox #mathCheck class="checkbox-format text-center checkbox-6b" color="primary"
            [checked]="selectedTpr.mathPerc === 100"
            [disabled]="!selectedTpr.designActualStart || disabled || reSourced || inActive || !fieldAuthorized('math')"
            (change)="onMathCheckChange($event)">
            Complete
        </mat-checkbox>
        <div class="display-style">
            <span class="label-wrapper">
                <mat-label *ngIf="getEtac()"> 10% Math:</mat-label>
                <mat-label *ngIf="!getEtac()"> 30% Model Complete:</mat-label>
            </span>
            <mat-form-field class="block no-underline bg-green">
                <input matInput class="input-wrapper" type="number" [(ngModel)]="selectedTpr.mathPerc"
                    [disabled]="!selectedTpr.designActualStart || disabled || reSourced || inActive || !fieldAuthorized('math')"
                    (change)="onMathPercChange(mathCheck)" name="mathInput" pattern="^$|^([0-9]|[1-9][0-9]|[1][0][0])?"
                    required #mathInput="ngModel"/>
                <div *ngIf="mathInput.errors && (mathInput.dirty || mathInput.touched)">
                    <div class="error-hint" [hidden]="!mathInput.errors.pattern">
                        Number should be between 0 and 100
                    </div>
                </div>
            </mat-form-field>
        </div>
    </mat-grid-tile>

    <mat-grid-tile colspan="2" class="align-items-inherit check-padding">
        <mat-checkbox #loCheck class="checkbox-format text-center checkbox-6b" color="primary"
            [checked]="selectedTpr.detail1Perc === 100"
            [disabled]="!selectedTpr.designActualStart || disabled || reSourced || inActive || !fieldAuthorized('detail1')"
            (change)="onLOCheckChange($event)">
            Complete
        </mat-checkbox>
        <div class="display-style">
            <span class="label-wrapper">
                <mat-label *ngIf="getEtac()"> 25% L/O, Det, Final:</mat-label>
                <mat-label *ngIf="!getEtac()"> 20% Model Reviewed:</mat-label>
            </span>
            <mat-form-field class="block no-underline bg-green">
                <input matInput class="input-wrapper" type="number" [(ngModel)]="selectedTpr.detail1Perc"
                    [disabled]="!selectedTpr.designActualStart || disabled || reSourced || inActive || !fieldAuthorized('detail1')"
                    (change)="onLOPercChange(loCheck)" name="detail1Input" pattern="^$|^([0-9]|[1-9][0-9]|[1][0][0])?"
                    required #detail1Input="ngModel"/>
                <div *ngIf="detail1Input.errors && (detail1Input.dirty || detail1Input.touched)">
                    <div class="error-hint" [hidden]="!detail1Input.errors.pattern">
                        Number should be between 0 and 100
                    </div>
                </div>
            </mat-form-field>
        </div>
    </mat-grid-tile>

    <mat-grid-tile colspan="2" class="align-items-inherit check-padding">
        <mat-checkbox #checkCheck class="checkbox-format text-center checkbox-6b" color="primary"
            [checked]="selectedTpr.checkedPerc === 100"
            [disabled]="!selectedTpr.designActualStart || disabled || reSourced || inActive || !fieldAuthorized('checked')"
            (change)="onCheckCheckChange($event)">
            Complete
        </mat-checkbox>
        <div class="display-style">
            <span class="label-wrapper">
                <mat-label *ngIf="getEtac()"> 10% Check:</mat-label>
                <mat-label *ngIf="!getEtac()"> 30% Ready for D'Bank:</mat-label>
            </span>
            <mat-form-field class="block no-underline bg-green">
                <input matInput class="input-wrapper" type="number" [(ngModel)]="selectedTpr.checkedPerc"
                    [disabled]="!selectedTpr.designActualStart || disabled || reSourced || inActive || !fieldAuthorized('checked')"
                    (change)="onCheckPercChange(checkCheck)" name="checkInput"
                    pattern="^$|^([0-9]|[1-9][0-9]|[1][0][0])?" required #checkInput="ngModel"/>
                <div *ngIf="checkInput.errors && (checkInput.dirty || checkInput.touched)">
                    <div class="error-hint" [hidden]="!checkInput.errors.pattern">
                        Number should be between 0 and 100
                    </div>
                </div>
            </mat-form-field>
        </div>
    </mat-grid-tile>

    <mat-grid-tile colspan="2" class="align-items-inherit check-padding">
        <mat-checkbox #opsCheck class="checkbox-format text-center checkbox-6b" color="primary"
            [checked]="selectedTpr.opsPerc === 100"
            [disabled]="!selectedTpr.designActualStart || disabled || reSourced || inActive || !fieldAuthorized('ops')"
            (change)="onOpsCheckChange($event)">
            Complete
        </mat-checkbox>
        <div class="display-style">
            <span class="label-wrapper">
                <mat-label *ngIf="getEtac()"> 5% OPS:</mat-label>
                <mat-label *ngIf="!getEtac()"> 10% Data has been Banked:</mat-label>
            </span>
            <mat-form-field class="block no-underline bg-green">
                <input matInput class="input-wrapper" type="number" [(ngModel)]="selectedTpr.opsPerc"
                    [disabled]="!selectedTpr.designActualStart || disabled || reSourced || inActive || !fieldAuthorized('ops')"
                    (change)="onOpsPercChange(opsCheck)" name="opsInput" pattern="^$|^([0-9]|[1-9][0-9]|[1][0][0])?"
                    required #opsInput="ngModel"/>
                <div *ngIf="opsInput.errors && (opsInput.dirty || opsInput.touched)">
                    <div class="error-hint" [hidden]="!opsInput.errors.pattern">
                        Number should be between 0 and 100
                    </div>
                </div>
            </mat-form-field>
        </div>
    </mat-grid-tile>

    <mat-grid-tile class="align-items-inherit check-padding" *ngIf="this.selectedTpr.designOnly" colspan="2">
        <div class="display-style">
            <span class="label-wrapper">
                <mat-label>TMaCs Required:</mat-label>
            </span>
            <mat-form-field class="no-underline body-wrapper block"
                [ngClass]="{'no-underline bg-red': selectedTpr.chgCfDesReq}">
                <input matInput class="input-wrapper" [ngModel]="selectedTpr.tmacsCfDesRqd | date:'M/d/y'"
                    (ngModel)="selectedTpr.tmacsCfDesRqd" readonly
                    [disabled]="disabled || reSourced || inActive || !fieldAuthorized('tmacsCfDesRqd')" />
            </mat-form-field>
        </div>

    </mat-grid-tile>
    <mat-grid-tile colspan="3" class="align-items-inherit">
        <div class="display-style">
            <span class="label-wrapper">
                <mat-label>Scheduled Finish:</mat-label>
            </span>
            <mat-form-field class="no-underline body-wrapper block">
                <input matInput class="input-wrapper" (ngModel)="selectedTpr.designSchedFinish"
                    [ngModel]="selectedTpr.designSchedFinish | date:'M/d/y'" readonly
                    [disabled]="disabled || reSourced || inActive || !fieldAuthorized('designSchedFinish')" />
            </mat-form-field>
        </div>

        <div class="display-style">
            <span class="label-wrapper">
                <mat-label>Actual Finish:</mat-label>
            </span>
            <mat-form-field class="display-field no-underline bg-green"
                matTooltip="Before entering an Actual Finish date, each phase must be 100% complete.  In addition, an Actual Start date must be entered.">
                <input matInput class="input-wrapper" [matDatepicker]="actualFinishDatepicker2"
                    [(ngModel)]="selectedTpr.designActualFinish" (dateChange)="onActualFinishChanged()"
                    [disabled]="!actualFinishEnabled() || disabled || reSourced || inActive || !fieldAuthorized('designActualFinish')" />
                <mat-datepicker-toggle matSuffix [for]="actualFinishDatepicker2"></mat-datepicker-toggle>
                <mat-datepicker #actualFinishDatepicker2></mat-datepicker>
            </mat-form-field>
        </div>

        <div class="display-style">
            <span class="label-wrapper">
                <mat-label>Forecast Finish:</mat-label>
            </span>
            <mat-form-field class="display-field no-underline bg-green">
                <input matInput class="input-wrapper" [matDatepicker]="forecastFinishDatepicker2"
                    [(ngModel)]="selectedTpr.designForecast"
                    [disabled]="disabled || reSourced || inActive || !fieldAuthorized('designForecast')"
                    (dateChange)="onGenericFieldChange('designForecast',selectedTpr.designForecast)" />
                <mat-datepicker-toggle matSuffix [for]="forecastFinishDatepicker2"></mat-datepicker-toggle>
                <mat-datepicker #forecastFinishDatepicker2></mat-datepicker>
            </mat-form-field>
        </div>
    </mat-grid-tile>
</mat-grid-list>

<mat-grid-list [cols]="4" gutterSize="10px" rowHeight="10px"> </mat-grid-list>

<mat-divider></mat-divider>

<mat-grid-list [cols]="4" gutterSize="25px" rowHeight="70px" class="dimensions-spacing">
    <mat-grid-tile class="align-items-inherit">
        <div class="display-style">
            <span class="label-wrapper">
                <mat-label>Approx Weight (lbs):</mat-label>
            </span>
            <mat-form-field class="block no-underline bg-green">
                <input matInput class="input-wrapper" [(ngModel)]="selectedTpr.approxWeight"
                    matTooltip="Please enter an integer.  For example, enter an integer in the following format:  9872.  Please do not enter commas, decimal points, or units of measures."
                    (change)="onGenericFieldChange('approxWeight',selectedTpr.approxWeight)"
                    [disabled]="disabled || reSourced || inActive || !fieldAuthorized('approxWeight')" />
            </mat-form-field>
        </div>
    </mat-grid-tile>

    <mat-grid-tile class="align-items-inherit">
        <div class="display-style">
            <span class="label-wrapper">
                <mat-label>Approx Length (mm):</mat-label>
            </span>
            <mat-form-field class="block no-underline bg-green"
                matTooltip="Please enter an integer.  For example, enter an integer in the following format:  9872.  Please do not enter commas, decimal points, or units of measures."
                (change)="onGenericFieldChange('approxLength',selectedTpr.approxLength)">
                <input matInput class="input-wrapper" [(ngModel)]="selectedTpr.approxLength"
                    [disabled]="disabled || reSourced || inActive || !fieldAuthorized('approxLength')" />
            </mat-form-field>
        </div>
    </mat-grid-tile>

    <mat-grid-tile class="align-items-inherit">
        <div class="display-style">
            <span class="label-wrapper">
                <mat-label>Approx Width (mm):</mat-label>
            </span>
            <mat-form-field class="block no-underline bg-green">
                <input matInput class="input-wrapper" [(ngModel)]="selectedTpr.approxWidth"
                    matTooltip="Please enter an integer.  For example, enter an integer in the following format:  9872.  Please do not enter commas, decimal points, or units of measures."
                    (change)="onGenericFieldChange('approxWidth',selectedTpr.approxWidth)"
                    [disabled]="disabled || reSourced || inActive || !fieldAuthorized('approxWidth')" />
            </mat-form-field>
        </div>
    </mat-grid-tile>

    <mat-grid-tile class="align-items-inherit">
        <div class="display-style">
            <span class="label-wrapper">
                <mat-label>Approx Height (mm)</mat-label>
            </span>
            <mat-form-field class="block no-underline bg-green">
                <input matInput class="input-wrapper" [(ngModel)]="selectedTpr.approxHeight"
                    matTooltip="Please enter an integer.  For example, enter an integer in the following format:  9872.  Please do not enter commas, decimal points, or units of measures."
                    (change)="onGenericFieldChange('approxHeight',selectedTpr.approxHeight)"
                    [disabled]="disabled || reSourced || inActive || !fieldAuthorized('approxHeight')" />
            </mat-form-field>
        </div>
    </mat-grid-tile>
</mat-grid-list>